export function GetQueryString(name) {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        window.location.href
      ) || [null, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
}
//替换指定传入参数的值,paramName为参数,replaceWith为新值
export function replaceParamVal(oUrl, paramName, replaceWith) {
  // var oUrl = this.location.href.toString();
  var re = new RegExp("[^?&]?" + paramName + "=[^=&#]*");
  var nUrl = oUrl.replace(re, paramName + "=" + replaceWith);
  return nUrl;
}
export default {
  GetQueryString: GetQueryString,
  replaceParamVal: replaceParamVal
};
